document.addEventListener('DOMContentLoaded', function() {
  // Selecciona el elemento que contiene el texto
  const titleElement = document.querySelector('.product__title h1, .product__title .h1');
  
  if (titleElement) {
    // Reemplaza el texto original con el texto resaltado
    let originalText = titleElement.textContent;
    let newText = originalText.replace(
      /(con Pienso GRATIS)/g, 
      '<span class="highlight">$1</span>'
    );
    titleElement.innerHTML = newText;
  }
});